<script>
  import Th from "../Tables/Th.svelte";
  import ThFilter from "../Tables/ThFilter.svelte";
  import RowsPerPage from "../Tables/RowsPerPage.svelte";
  import RowCount from "../Tables/RowCount.svelte";
  import Pagination from "../Tables/Pagination.svelte";
  import { DataHandler, check, Datatable } from "@vincjo/datatables";
  import {
    API_DIR,
    SESSION_LS,
    selectedDeviceId,
    selectedPage,
    showLoadingModal,
    uniqueAppIdValuesList
  } from "../store";
  import { convertUnixToDate, downloadCSV } from "../Utils.svelte";
  import { onMount } from "svelte";
  import Select from "svelte-select";
  import { toasts } from "svelte-toasts";

  let responseJsonData = [];

  //console.log(responseJsonData);

  let fileInputFirmware;
  let handler = new DataHandler(responseJsonData, { rowsPerPage: 20 });
  let rows = handler.getRows();
  let selected = handler.getSelected();
  let isAllSelected = handler.isAllSelected();
  let disabled;
  //let allowOverwrite = false;
  let fileNotesInput;
  let versionInput = "";
  let categoryInput = "";
  let selectedTechnologyOptions = [];
  let appIdSelection = [];
  let firmwareTypes = ["LMU", "JPOD", "JPOD2"];
  let firmwareTypeInput = firmwareTypes[0];
  let isMounted = false;
  let btnModalClose;
  let fComment = "";
  let isFormValid = false;
  let authString = "";
  let allowedCompany = [];
  let platformOptions = [
    "MDM9205",
    "H8",
    "STM32F2",
    "MDM9207",
    "STM32G4",
    "Antaris",
    "STR710",
    "ARM9",
    "STM32L471",
    "IMX6",
    "STM32",
    "STM32L4A6",
    "TC65",
    "STM8"
  ];

  let categoryOptions = [
    "VLUP",
    "LMU",
    "LAD",
    "TTU",
    "LMU-VLU",
    "RMU",
    "LMU-HMU",
    "PTU",
    "LMU-BAR",
    "ATU-BAR",
    "MTU",
    "Legacy"
  ];

  let technologyOptions = [
    "LTE",
    "LTE (Cat M1)",
    "2G FB",
    "BLE",
    "HSPA",
    "LTE (Cat 1)",
    "MDM9207 ATT M14Q2FG-1",
    "MDM9207 VZW A18Q4",
    "GSM",
    "3GCELL",
    "IDEN",
    "CDMA",
    "Bluetooth",
    "Wifi",
    "LTE (Cat M1)",
    "CDPD",
    "GSM",
    "Legacy"
  ];

  // $: $selectedDeviceId, console.log($selectedDeviceId); //DeviceDetail

  $: $selected, switchEnable();

  async function checkFileFormat(event) {
    const fileInput = event.target;
    const file = fileInput.files[0];

    // Verificar si se ha seleccionado un archivo
    if (!file) {
      fileInputFirmware.value = null;
      alert("No se ha seleccionado ningún archivo.");
      return;
    }

    // Verificar si el título del archivo contiene caracteres especiales
    const forbiddenChars = /[!@#$%^&*()+=\[\]{};':"\\|,.<>\/?\s]+/;
    const fileNameWithoutExtension = file.name.replace(/\.[^/.]+$/, "");
    if (forbiddenChars.test(fileNameWithoutExtension)) {
      fileInput.value = ""; // Limpiar el valor del input file
      fileInputFirmware.value = null;
      toasts.info("File title cannot contain special characters.");
      return;
    }

    // Verificar si el contenido del archivo tiene formato CSV
    const reader = new FileReader();
    reader.onload = function (event) {
      const content = event.target.result;
      if (isCSV(content)) {
        toasts.info("The file may contain CSV data.");
        //fileInput.value = "";
        //fileInputFirmware.value = null;
      } /*else {
        fileInputFirmware.files[0] = file;
      }*/
    };
    reader.readAsText(file);
  }

  function isCSV(content) {
    // Dividir el contenido del archivo en líneas
    const lines = content.split("\n");

    // Verificar si la primera línea contiene separadores de coma
    if (lines.length > 0 && lines[0].includes(",")) {
      //console.log("contains separations");
      return true;
    }

    // Verificar si la mayoría de las líneas tienen separadores de coma
    const commaCount = lines.reduce(
      (count, line) => count + (line.includes(",") ? 1 : 0),
      0
    );
    const totalLines = lines.length;

    if (commaCount >= totalLines / 2) {
      //console.log("la mayoría de las líneas tienen separadores de coma");

      return true;
    }

    return false;
  }

  function checkFormValidity() {
    const missingFields = [];

    if (appIdSelection.length === 0) {
      missingFields.push("App IDs");
    }

    if (selectedTechnologyOptions.length === 0) {
      missingFields.push("Technology");
    }

    if (versionInput.trim() === "") {
      missingFields.push("Version");
    }

    if (firmwareTypeInput.trim() === "") {
      missingFields.push("FirmwareType");
    }

    if (categoryInput.trim() === "") {
      missingFields.push("category");
    }

    if (fComment.trim() === "") {
      missingFields.push("Comment");
    }

    try {
      if (fileInputFirmware.files.length === 0) {
        missingFields.push("File");
      }
    } catch (error) {
      missingFields.push("File");
    }

    console.log(missingFields);
    isFormValid = missingFields.length === 0;
  }

  async function fetchFirmwareData() {
    try {
      showLoadingModal.set(true);

      const response = await fetch(`${$API_DIR}/api/v1/get-firmwares`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Session-Id": localStorage.getItem($SESSION_LS)
        }
      });
      showLoadingModal.set(false);

      if (response.status === 401) {
        location.reload();
      }
      if (!response.ok) {
        throw new Error("Error al obtener los archivos de configuración");
      }
      const data = await response.json();

      if (data.length > 0) {
        return data;
      } else {
        return [];
      }
    } catch (error) {
      console.log("Error:", error);
    }
  }

  function switchEnable() {
    if (isMounted) {
      disabled = $selected.length == 0 ? true : false;
    }
  }

  function toggleButton(row) {
    console.log(row);
    /*row.device_updates =
      row.device_updates === "enabled" ? "disabled" : "enabled";*/
  }

  function handleAppIdSelection(e) {
    try {
      appIdSelection = e.detail.map((obj) => obj.value);
    } catch (error) {
      appIdSelection = [];
    }
    checkFormValidity();
  }

  function handleTechnologySelection(e) {
    try {
      selectedTechnologyOptions = e.detail.map((obj) => obj.value);
    } catch (error) {
      selectedTechnologyOptions = [];
    }
    checkFormValidity();
  }

  function readFileAsArrayBuffer(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.onerror = () => {
        reject(new Error("Error al leer el archivo."));
      };

      reader.readAsArrayBuffer(file);
    });
  }

  async function setUpTable() {
    responseJsonData = await fetchFirmwareData();
    handler = new DataHandler(responseJsonData, { rowsPerPage: 15 });
    rows = handler.getRows();
    selected = handler.getSelected();
    isAllSelected = handler.isAllSelected();
    disabled = true;
  }

  async function saveFile() {
    if (isFormValid) {
      const file = fileInputFirmware.files[0];
      const fileData = await readFileAsArrayBuffer(file);

      //const blob = new Blob([fileData], { type: "application/octet-stream" });

      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Session-Id": localStorage.getItem($SESSION_LS)
        },
        body: JSON.stringify({
          //allowOverwrite: allowOverwrite,
          filename: file.name,
          comment: fComment,
          compatible_app_id: appIdSelection,
          version: versionInput,
          type: firmwareTypeInput,
          category: categoryInput,
          technology: selectedTechnologyOptions,
          file_data: Array.from(new Uint8Array(fileData)),
          auth: authString
        })
      };

      //console.log("request", requestOptions);

      try {
        showLoadingModal.set(true);

        const response = await fetch(
          `${$API_DIR}/api/v1/save-firmware-file`,
          requestOptions
        );

        showLoadingModal.set(false);

        if (response.ok) {
          btnModalClose.click();
          toasts.success("File successfully uploaded.");
          await setUpTable();
        } else if (response.status === 401) {
          location.reload();
        } else if (response.status === 410) {
          toasts.warning("A file with the same params already exist.");
        } else if (response.status === 409) {
          toasts.warning("File already exist.");
        } else {
          toasts.error("Could not save file.");
        }
      } catch (error) {
        toasts.error("Could not save file.");
      }
      appIdSelection = [];
      selectedTechnologyOptions = [];
      versionInput = "";
      fileInputFirmware.value = null;
      categoryInput = "";
      fComment = "";
      checkFormValidity();
    }
  }

  async function deleteFirmwareFiles() {
    //console.log($selected);
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Session-Id": localStorage.getItem($SESSION_LS)
      },
      body: JSON.stringify({
        filenames: $selected
      })
    };

    try {
      showLoadingModal.set(true);

      const response = await fetch(
        `${$API_DIR}/api/v1/delete-firmware-files`,
        requestOptions
      );

      showLoadingModal.set(false);

      if (response.ok) {
        const data = await response.json();
        console.log(data.message);
        toasts.success("File successfully deleted.");
        await setUpTable();
      } else if (response.status === 401) {
        location.reload();
      } else if (response.status === 409) {
        toasts.error("One or more files are currently in use.");
      } else {
        const errorData = await response.json();
        console.log(errorData.error);
      }
    } catch (error) {
      console.log("Error en la solicitud al servidor:", error);
    }
  }

  onMount(async () => {
    disabled = true;
    fileNotesInput = document.getElementById("fileNotesInput");
    fileInputFirmware = document.getElementById("formFileFirmware");
    btnModalClose = document.getElementById("btn-modal-close");

    await setUpTable();
    isMounted = true;
  });
</script>

{#if isMounted}
  <hr />

  <div class="row">
    <div class="col-lg-6">
      <h2>Firmware Files</h2>
    </div>
    <div class="col-lg-6">
      <div class="d-flex justify-content-end">
        <div style="margin-top: 4px;">
          <RowsPerPage {handler} />
        </div>

        <button
          {disabled}
          id="btn-config"
          type="button"
          class="btn btn-danger"
          style="margin-left:16px"
          on:click={deleteFirmwareFiles}
        >
          <i class="bi bi-trash-fill" /> Delete</button
        >

        <button
          id="btn-add-firmware"
          type="button"
          class="btn btn-primary"
          style="margin-left:16px"
          data-bs-toggle="modal"
          data-bs-target="#addFirmwareModal"
          on:click={() => {}}
        >
          <i class="bi bi-file-earmark-plus-fill" /> Add</button
        >
      </div>
    </div>
  </div>
  <hr />

  <!--<div class="table-responsive">-->

  <div class="table-responsive">
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th class="selection">
            <input
              type="checkbox"
              on:click={() => handler.selectAll({ selectBy: "filename" })}
              checked={$isAllSelected}
            />
          </th>

          {#each Object.keys(responseJsonData[0]) as obj}
            <Th {handler} orderBy={obj}>{obj.toUpperCase()}</Th>
          {/each}
        </tr>
        <tr>
          <th class="selection" />

          {#each Object.keys(responseJsonData[0]) as obj}
            <ThFilter {handler} filterBy={obj} />
          {/each}
        </tr>
      </thead>
      <tbody style="table-striped">
        {#each $rows as row}
          <tr class:active={$selected.includes(row.filename)}>
            <td class="selection">
              <input
                type="checkbox"
                on:click={() => handler.select(row.filename)}
                checked={$selected.includes(row.filename)}
              />
            </td>

            {#each Object.keys(responseJsonData[0]) as obj}
              {#if obj == "active" || obj == "notes" || obj == "creation_date" || obj == "auth"}
                {#if obj == "active"}
                  <td align="center" style="white-space: nowrap">
                    <div
                      class={row[obj.toString()] == true
                        ? " badge bg-success"
                        : "badge bg-secondary"}
                    >
                      {row[obj.toString()]}
                    </div>
                  </td>
                {/if}

                {#if obj == "auth"}
                  <td align="center" style="white-space: nowrap">
                    {#if row[obj.toString()] != ""}
                      <div class="badge bg-success">true</div>
                    {:else}
                      <div class="badge bg-secondary">false</div>
                    {/if}
                  </td>
                {/if}

                {#if obj == "notes"}
                  <td align="center" style="white-space: nowrap">
                    {#if row[obj.toString()] == "Release Notes"}
                      <button type="button" class="btn btn-link"
                        >{row[obj.toString()]}</button
                      >
                    {:else}
                      <td align="center" style="white-space: nowrap"
                        >{row[obj.toString()]}</td
                      >
                    {/if}
                  </td>
                {/if}

                {#if obj == "creation_date"}
                  <td align="center" style="white-space: nowrap">
                    {convertUnixToDate(row[obj])}
                  </td>
                {/if}
              {:else}
                <td align="center" style="white-space: nowrap"
                  >{row[obj.toString()]}</td
                >
              {/if}
            {/each}
          </tr>
        {/each}
      </tbody>
    </table>
  </div>

  <br />

  <div class="row">
    <div class="col d-flex justify-content-end">
      <RowCount {handler} />
      <div style="width: 12px;" />
      <Pagination {handler} />
    </div>
  </div>

  <br />
{/if}
<!-- Modal -->
<div
  class="modal fade"
  id="addFirmwareModal"
  tabindex="-1"
  aria-labelledby="addFirmwareModallLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="addFirmwareModallLabel">
          Add Firmware File
        </h5>
        <button
          id="btn-modal-close"
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        />
      </div>
      <div class="modal-body">
        <div class="input-group mb-3 row" style="margin-left: inherit;">
          <span class="input-group-text col" style="max-width: fit-content;"
            >App ID</span
          >
          <Select
            class="col"
            items={$uniqueAppIdValuesList}
            value={appIdSelection}
            placeholder="Selecciona una o más opciones"
            selected={appIdSelection}
            multiple
            on:input={handleAppIdSelection}
          />
        </div>
        <div class="input-group mb-3">
          <span class="input-group-text">Version</span>
          <input
            type="text"
            class="form-control"
            placeholder="version"
            aria-describedby="basic-addon1"
            bind:value={versionInput}
            on:input={() => {
              checkFormValidity();
            }}
          />
        </div>

        <div class="input-group mb-3">
          <span class="input-group-text">Firmware Type</span>

          <select
            class="form-select"
            id="platformSelectionInput"
            bind:value={firmwareTypeInput}
            on:change={() => {
              checkFormValidity();
            }}
          >
            {#each firmwareTypes as option}
              <option value={option}>
                {option}
              </option>
            {/each}
          </select>
        </div>

        <div class="input-group mb-3">
          <span class="input-group-text">Category</span>
          <select
            class="form-select"
            id="categorySelectionInput"
            bind:value={categoryInput}
            on:change={() => {
              checkFormValidity();
            }}
          >
            {#each categoryOptions as option}
              <option value={option}>
                {option}
              </option>
            {/each}
          </select>
        </div>

        <div class="input-group mb-3 row" style="margin-left: inherit;">
          <span class="input-group-text col" style="max-width: fit-content;"
            >Technology</span
          >
          <Select
            class="col"
            items={technologyOptions}
            value={selectedTechnologyOptions}
            placeholder="Selecciona una o más opciones"
            selected={technologyOptions}
            multiple
            on:input={handleTechnologySelection}
          />
        </div>

        <div class="input-group">
          <span class="input-group-text">Notes</span>
          <textarea
            id="fileNotesInput"
            class="form-control"
            placeholder="Add a comment"
            bind:value={fComment}
            on:input={() => {
              checkFormValidity();
            }}
          />
        </div>

        <hr />

        <div class="mb-3">
          <input
            class="form-control"
            type="file"
            id="formFileFirmware"
            accept="*"
            on:change={async (event) => {
              await checkFileFormat(event);
              fileInputFirmware = event.target;
              if (
                fileInputFirmware.files &&
                fileInputFirmware.files.length > 0
              ) {
                //selectedFile = fileInputFirmware.files[0];
                checkFormValidity(); // Llamamos a la función para actualizar el estado del botón
              } else {
                //selectedFile = null;
                checkFormValidity(); // Llamamos a la función para actualizar el estado del botón
              }
            }}
          />
        </div>

        <hr />

        <div class="input-group">
          <span class="input-group-text">Auth</span>
          <input
            type="text"
            class="form-control"
            placeholder="Auth String (optional)"
            aria-describedby="basic-addon1"
            bind:value={authString}
          />
        </div>

        <!--<div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            id="flexCheckDefault"
            bind:checked={allowOverwrite}
          />
          <label class="form-check-label" for="flexCheckDefault">
            Allow Overwrite
          </label>
        </div>-->
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
          >Close</button
        >
        <div class="d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-success"
            on:click={saveFile}
            disabled={!isFormValid}
            ><i class="bi bi-table" /> Upload Firmware</button
          >
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  thead th.selection {
    width: 48px;
    padding-left: 24px;
  }
  tbody tr {
    transition: all, 0.2s;
  }

  td.selection {
    padding-left: 24px;
  }
</style>
